/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { CommentCreatedData } from './commentCreatedData';


/**
 * WebSocket notification for new comment created.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommentCreatedNotification { 
    /**
     * Always \'comment.created\'
     */
    readonly type: string;
    data: CommentCreatedData;
    toast?: ToastConfig | null;
}
export const CommentCreatedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedNotification_toast_Validators: ValidatorFn[] =
    [ ];


